import { doc, updateDoc, getDoc } from "firebase/firestore";
import { auth, fs } from "../firebase.ts";

export class Hero {
    public async get() {
        const user = auth.currentUser;
        if (user) {
            const userDocRef = doc(fs, "users", user.uid);
            const snap = await getDoc(userDocRef);
            return snap.exists() ? snap.data() : null;
        } else return null;
    }

    async updateLanguage(languageCode: string) {
        const user = auth.currentUser;
        if (!user) throw new Error("Authenticated users only");
        const userDocRef = doc(fs, "users", user.uid);
        await updateDoc(userDocRef, { languageCode });
        return "Your language has been updated successfully.";
    }

    // TODO:
    async updateTimezone(timezone: string) {
        const user = auth.currentUser;
        if (!user) throw new Error("Authenticated users only");
        const userDocRef = doc(fs, "users", user.uid);
        await updateDoc(userDocRef, { timezone });
        return "Your time zone has been updated successfully.";
    }

    async updateTip(isTip: boolean) {
        const user = auth.currentUser;
        if (!user) throw new Error("Authenticated users only");
        const userDocRef = doc(fs, "users", user.uid);
        await updateDoc(userDocRef, { isTip });
        return "Your tip status has been updated successfully.";
    }

    async updateBroadcast(isBroadcast: boolean) {
        const user = auth.currentUser;
        if (!user) throw new Error("Authenticated users only");
        const userDocRef = doc(fs, "users", user.uid);
        await updateDoc(userDocRef, { isBroadcast });
        return "Your broadcast status has been updated successfully.";
    }

    async updateSos(isSos: boolean) {
        const user = auth.currentUser;
        if (!user) throw new Error("Authenticated users only");
        const userDocRef = doc(fs, "users", user.uid);
        await updateDoc(userDocRef, { isSos });
        return "Your SOS status has been updated successfully.";
    }

    async updateSidekick(isSidekick: boolean) {
        const user = auth.currentUser;
        if (!user) throw new Error("Authenticated users only");
        const userDocRef = doc(fs, "users", user.uid);
        await updateDoc(userDocRef, { isSidekick });
        return "Your 3 (Sidekick AI) status has been updated successfully.";
    }

    async updateRecord(isRecord: boolean) {
        const user = auth.currentUser;
        if (!user) throw new Error("Authenticated users only");
        const userDocRef = doc(fs, "users", user.uid);
        await updateDoc(userDocRef, { isRecord });
        return "Your record status has been updated successfully.";
    }

    async updateFeatures(features: Object) {
        const user = auth.currentUser;
        if (!user) throw new Error("Authenticated users only");
        const userDocRef = doc(fs, "users", user.uid);
        await updateDoc(userDocRef, { features: JSON.stringify(features) });
        return "Your advanced feature settings have been updated successfully.";
    }
}
